export const selectPriceAlerts = (state) => state.priceAlerts.data;

export const selectPriceAlertsPhone = (state) =>
  state.priceAlerts.data?.[0]?.Phone;

export const selectPriceAlert = (state) => state.priceAlerts.priceAlert;

export const selectPriceAlertPhone = (state) =>
  state.priceAlerts.priceAlert?.Phone;
